/** GHL survey widget URL for /quote */
export const GHL_SURVEY_EMBED_URL =
	'https://api.leadconnectorhq.com/widget/survey/GG0zcwcTFA67RvqV6CVz?notrack=true';
